export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["UNKNOWN"] = "UNKNOWN";
    /** show this plan on app market */
    PlanStatus["VISIBLE"] = "VISIBLE";
    /** hide this plan */
    PlanStatus["HIDDEN"] = "HIDDEN";
})(PlanStatus || (PlanStatus = {}));
export var PlanDescription;
(function (PlanDescription) {
    PlanDescription["UNKNOWN_DESCRIPTION"] = "UNKNOWN_DESCRIPTION";
    /** indicate that the description will be list of benefits */
    PlanDescription["BENEFITS"] = "BENEFITS";
    /** indicate that the description will custom_text field */
    PlanDescription["CUSTOM_TEXT"] = "CUSTOM_TEXT";
})(PlanDescription || (PlanDescription = {}));
export var BusinessModel;
(function (BusinessModel) {
    BusinessModel["None"] = "None";
    BusinessModel["FREEMIUM"] = "FREEMIUM";
    BusinessModel["PREMIUM"] = "PREMIUM";
    BusinessModel["FREE"] = "FREE";
    BusinessModel["WIX_PREMIUM"] = "WIX_PREMIUM";
    BusinessModel["DYNAMIC"] = "DYNAMIC";
})(BusinessModel || (BusinessModel = {}));
//# sourceMappingURL=types.impl.js.map